module.exports = __webpack_public_path__ + "backImg01.f4681541.png";